module.exports = __webpack_public_path__ + "static/img/9.b7f8379.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/9.png
// module id = f8oe
// module chunks = 0